import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=007a8313&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"
import style0 from "./Title.vue?vue&type=style&index=0&id=007a8313&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a8313",
  null
  
)

export default component.exports